import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useMemo } from "react";
import { css } from "styled-components";
import { withHistory } from "@insite/mobius/utilities/HistoryContext";
import getColor from "@insite/mobius/utilities/getColor";


{/* EC-232 : SubTask - EC-516 = Wizard Structure of the form Progress Bar  */}

export interface QouteCartFormStyles {
    progressBarContainer?: InjectableCss;
}

export const qouteCartFormStyles: QouteCartFormStyles = {
   progressBarContainer: {
	css: css`
		ul{
			counter-reset: step 0;
			display: flex;
			justify-content: space-evenly;
			li{
				width: 33.33%;
				justify-content: flex-start;
				position: relative;
				display: flex;
				flex-direction: column;
				-webkit-box-align: center;
				align-items: center;
				font-size: 16px;
				line-height: 24px;
				font-weight: 600;
				margin-top: 10px;
				&:before{
					content: counter(step);
					counter-increment: step 1;
					width: 40px;
					height: 40px;
					text-align: center;
					border-radius: 50%;
					background: ${getColor("primary.contrast")};
					border: 2px solid ${getColor("common.border")};
					font-weight: 600;
					font-size: 16px;
					line-height: 24px;
					z-index: 1;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				&.active-li{
					&:before{
						background-color: ${getColor("primary")};
					}
				}
				&:after{
					content: "";
					border: 2px solid ${getColor("secondary")};
					width: 100%;
					position: absolute;
					top: 20px;
					left: -50%;
				}
				&:first-child{
					&:after{
						content: "";
    					border: none;
					}
				}
				span{
					text-align: center;
					font-weight: 400;
					font-size: 16px;
					line-height: 24px;
					margin-top: 10px;
					${({ theme }) =>
						breakpointMediaQueries(
							theme,
							[
								css`
									font-size:14px;
									line-height: 20px;
								`,
								css`
									font-size:14px;
									line-height: 20px;
								`,
								null,
								null,
								null,
							],
							"max",
					)}
					.text-part-1, .text-part-2 {
						display: inline;
						margin-top: 0;
					}
					.text-part-1 {
						${({ theme }) =>
						breakpointMediaQueries(
							theme,
							[
								css`
									display: block;
								`,
								css`
									display: block;
								`,
								null,
								null,
								null,
							],
							"max",
						)}
					}
				}
			}
		}
	`
   },
};

const steps = [
    { path: "guest-user-form", label: translate("Customer Information") },
    { path: "guest-user-billing-info", label: translate("Billing/Shipping Information") },
    { path: "quote-preview-and-edit", label: translate("Review & Submit") },
];

const GuestCustomerProgressBar = () => {
    const currentPath = typeof window !== "undefined" ? window.location.pathname : "";

    const progressItems = useMemo(
        () =>
            steps.map(({ path, label }) => {
                const isActive = currentPath.includes(path);
                return (
                    <li key={path} className={isActive ? "active-li" : ""}>
                        <Typography as="span" style={{ fontWeight: isActive ? "bold" : "normal" }}>
                            {label}
                        </Typography>
                    </li>
                );
            }),
        [currentPath]
    );

    return (
        <StyledWrapper {...qouteCartFormStyles.progressBarContainer} id="BackToTop">
            <ul>{progressItems}</ul>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(GuestCustomerProgressBar),
    definition: {
        displayName: "Guest User Progress Bar",
        group: "Common",
    },
};

export default widgetModule;

{/* EC-232 : SubTask - EC-516 = Wizard Structure of the form Progress Bar  */}
